import SectionHeading from "@/components/base/SectionHeading";

const principles = [
  {
    title: "先快，再准确",
    text: "突发事件讲究时效，我们先把已经确认的部分讲清楚，并明确标注哪些信息仍在核实，避免把推测写成结论。",
  },
  {
    title: "进展不重发，直接补",
    text: "同一件事的后续进展会合并到原条目中更新，而不是另起一篇重复发布，读者回看时能看到完整脉络。",
  },
  {
    title: "标注来源与时间",
    text: "每条内容都会写明来源与更新时间。信息出现变化时，在文末说明修改内容与修改时间。",
  },
  {
    title: "不替读者下判断",
    text: "在事实之外，我们尽量呈现不同方面的说法，把判断留给读者，不用情绪化的措辞替人做决定。",
  },
  {
    title: "尊重当事人的边界",
    text: "涉及个人隐私、未成年人或正在处理中的事件时，我们会克制细节披露，不做过度挖掘。",
  },
  {
    title: "接受更正与监督",
    text: "欢迎通过反馈渠道指出问题。核实后我们会尽快更正，并把更正记录保留在页面上。",
  },
];

export default function Principles() {
  return (
    <section aria-label="内容原则" className="mx-auto max-w-[1400px] px-4 md:px-6">
      <SectionHeading
        title="我们的内容原则"
        subtitle="决定一条内容写不写、怎么写时，我们遵循这几条"
        icon="ri-book-2-line"
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {principles.map((item, index) => (
          <article
            key={item.title}
            className="rounded-lg border border-background-200 bg-background-50 p-5"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 font-serif-cn text-sm font-bold text-accent-800">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="font-serif-cn text-base font-semibold text-foreground-950">
                {item.title}
              </h3>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}